var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.value)+" "),(_vm.important)?_c('span',{staticClass:"important"},[_vm._v("*")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }